import { defineMessages } from 'react-intl';

export default defineMessages({
  address: 'Address',
  votes: 'Votes',

  yes: 'YAE',
  noDataYes: `Nobody has voted 'YAE' yet`,

  no: 'NAY',
  noDataNo: `Nobody has voted 'NAY' yet`,
});
